import styled from 'styled-components'

export const Title = styled.h1`
    font-size: 20px;
    font-weight: 800;
`
